import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {screenSizeSmaller} from 'views/components';

import NavbarBigScreen from './navbar_big_screen';
import NavbarSmallScreen from './navbar_small_screen';

const NavBar = (props) => {
  const mobileApp = props.mobileApp;

  const smallScreen = screenSizeSmaller('navbarHide');

  const [account, setAccount] = React.useState('care');

  if (mobileApp) {
    // Don't show on mobile app
    return null;
  }


  if (smallScreen) {
    return (
      <NavbarSmallScreen account={account} setAccount={setAccount} />
    );
  }

  return (
    <NavbarBigScreen account={account} setAccount={setAccount} />
  );
};


NavBar.propTypes = {
  mobileApp: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  mobileApp: state.environment.mobileApp,
});

export default connect(mapStateToProps, dispatch)(React.memo(NavBar));
